// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2ultz","icon":"SortAdornment_icon__3awKf","up":"SortAdornment_up__1245I","down":"SortAdornment_down__pQXak","active":"SortAdornment_active__1Sx8V"};